import { React, useEffect, useState } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Tooltip,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import {
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../pageStyled";
import Multiselect from "multiselect-react-dropdown";
import styled from "styled-components";
import {
  lengthUnit,
  weightUnit,
currency_List 

} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import {
  getUnitData,
  updateUnitData,
} from "../../../Services/measurementService";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import LengthConversionUnitDrawer from "../AdvancedSettings/LengthConversionUnitDrawer";
import ExchangeRateDrawer from "./ExchangeRateDrawer";
import HistoricalExchangeRateDrawer from "./HistoricalExchangeRateDrawer";

const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "none",

    "border-radius": "0px",
  },
  option: {
    // To change css for dropdown options
    //background : "gray"
  },
};

const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
`;

const { Option } = Select;

const { TextArea } = Input;

const MeasurementSystem = (props) => {
  const [action, setAction] = useState("view");
  const [selectedLengthUnit, setSelectedLengthUnit] = useState();
  const [selectedWeightUnit, setSelectedWeightUnit] = useState();
  const [lengthUnitData, setLengthUnit] = useState();
  const [weightUnitData, setWeightUnit] = useState();
  const [lengthUnitDefault, setLengthUnitDefault] = useState();
  const [weightUnitDefault, setWeightUnitDefault] = useState();
  const [selectedCurrencyUnit, setSelectedCurrencyUnit] = useState();
  const [form] = Form.useForm();
  const [rendering, setRendering] = useState(true);
  const [editToaster, setEditToaster] = useState(false);
  const [visible, setVisible] = useState(false);
  const [lengthDrawerVisible, setLengthDrawerVisible] = useState(false);
  const [weightDrawerVisible, setWeightDrawerVisible] = useState(false);
  const [exchangeRateDrawerVisible,setExchangeRateDrawerVisible] = useState(false);
  const [historyDrawerVisible,setHistoryDrawerVisible] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const lengthData = Object.values(lengthUnit);
  const weightData = Object.values(weightUnit);
  
  useEffect(() => {
    if (rendering) {
      getUnitData()
        .then((response) => {
          const filteredSelectedLengthUnit = lengthData.filter((elem) => {
            return response.data.units_management.length.data.some((ele) => {
              return ele === elem.value;
            });
          });

          const filteredSelectedWeightUnit = weightData.filter((elem) => {
            return response.data.units_management.weight.data.some((ele) => {
              return ele === elem.value;
            });
          });

          const filteredSelectedCurrencyUnit = currency_List.filter((elem) => {
            return response.data.units_management.currency.data.some((ele) => {
              return ele === elem.code;
            });
          });

          setSelectedLengthUnit(filteredSelectedLengthUnit);
          setSelectedWeightUnit(filteredSelectedWeightUnit);
          setLengthUnit(filteredSelectedLengthUnit);
          setWeightUnit(filteredSelectedWeightUnit);
          setLengthUnitDefault(response.data.units_management.length.default);
          setWeightUnitDefault(response.data.units_management.weight.default)
          setSelectedCurrencyUnit(filteredSelectedCurrencyUnit);
          form.setFieldsValue({
            default_currency_unit:
              response.data.units_management.currency.default,
            default_weight_unit: response.data.units_management.weight.default,
            default_length_unit: response.data.units_management.length.default,
          });
        })
        .catch((error) => console.log(error));
      setRendering(false);
    }
  }, [rendering]);

  const onClickLengthDrawer = () => {
    setLengthDrawerVisible(true);
  };

  const onClickWeightDrawer = () => {
    setWeightDrawerVisible(true);
  };

  const onCloseLengthDrawer = () => {
    setLengthDrawerVisible(false);
  };

  const onCloseWeightDrawer = () => {
    setWeightDrawerVisible(false);
  };

  const onClickCurrencyDrawer = () => {
    setExchangeRateDrawerVisible(true);
  };

  const onCloseCurrencyDrawer = () => {
    setExchangeRateDrawerVisible(false);
  };

  const onClickHistoryDrawer = () => {
    setExchangeRateDrawerVisible(false);
    setHistoryDrawerVisible(true);
  };

  const onBackExchangeRate = () => {
    setHistoryDrawerVisible(false);
    setExchangeRateDrawerVisible(true);
  }

  const onCloseHistoryDrawer = () => {
    setHistoryDrawerVisible(false);
  };

  const modalCancel = () => {
    setVisible(false);
  };

  const modalConfirm = () => {
    setVisible(false);
    setRendering(true);
    setAction("view");
  };

  const onChangeLengthUnitSelect = (value) => {
    setSelectedLengthUnit(value);
    const filteredUnit = value.find(
      (data) => data.value == form.getFieldValue("default_length_unit")
    );
    if (!filteredUnit) {
      form.setFieldsValue({ default_length_unit: "" });
    }
  };

  const onChangeWeightUnitSelect = (value) => {
    setSelectedWeightUnit(value);
    const filteredUnit = value.find(
      (data) => data.value == form.getFieldValue("default_weight_unit")
    );
    if (!filteredUnit) {
      form.setFieldsValue({ default_weight_unit: "" });
    }
  };

  const onChangeCurrencyUnitSelect = (value) => {
    setSelectedCurrencyUnit(value);
    const filteredUnit = value.find(
      (data) => data.code == form.getFieldValue("default_currency_unit")
    );
    if (!filteredUnit) {
      form.setFieldsValue({ default_currency_unit: "" });
    }
  };

  const handleEdit = () => {
    setAction("edit");
  };

  const handleSave = () => {
    form.submit();
  };

  const onFinish = () => {
    if (
      (selectedLengthUnit.length,
      selectedWeightUnit.length,
      selectedCurrencyUnit.length)
    ) {
      const req = {
        length: {
          data: selectedLengthUnit.map((data) => data.value),
          default: form.getFieldValue("default_length_unit"),
        },
        weight: {
          data: selectedWeightUnit.map((data) => data.value),
          default: form.getFieldValue("default_weight_unit"),
        },
        currency: {
          data: selectedCurrencyUnit.map((data) => data.code),
          default: form.getFieldValue("default_currency_unit"),
        },
      };
      updateUnitData(req)
        .then((response) => {
          setEditToaster(true);
          setTimeout(() => setEditToaster(false), 3000);
          setRendering(true);
          setAction("view");
        })
        .catch((error) => console.log(error));
      setRendering(false);

      console.log(req);
    }
  };

  const handleCancel = () => {
    setVisible(true);
  };

  const removeLength = (unit) => {
    let array = selectedLengthUnit;
    let newArray = array.filter((item) => {
      return !(item.label === unit.label && item.value === unit.value);
    });
    setSelectedLengthUnit(newArray);
    const filteredUnit = newArray.find(
      (data) => data.value == form.getFieldValue("default_length_unit")
    );
    if (!filteredUnit) {
      form.setFieldsValue({ default_length_unit: "" });
    }
  };

  const removeWeight = (unit) => {
    let array = selectedWeightUnit;
    let newArray = array.filter((item) => {
      return !(item.label === unit.label && item.value === unit.value);
    });
    setSelectedWeightUnit(newArray);
    const filteredUnit = newArray.find(
      (data) => data.value == form.getFieldValue("default_weight_unit")
    );
    if (!filteredUnit) {
      form.setFieldsValue({ default_weight_unit: "" });
    }
  };

  const removeCurrency = (unit) => {
    let array = selectedCurrencyUnit;
    let newArray = array.filter((item) => {
      return !(item.code === unit.code);
    });
    setSelectedCurrencyUnit(newArray);
    const filteredUnit = newArray.find(
      (data) => data.code == form.getFieldValue("default_currency_unit")
    );
    if (!filteredUnit) {
      form.setFieldsValue({ default_currency_unit: "" });
    }
  };

  return selectedCurrencyUnit && selectedLengthUnit && selectedWeightUnit ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          //onBack={action === "view" && routeBack}
          title={"Measurement System"}
          extra={
            action === "edit"
              ? [
                  <Button
                    key="1"
                    className="textTypeBtn"
                    onClick={handleCancel}
                  >
                    Cancel changes
                  </Button>,
                  <Button key="3" className="themeBtn" onClick={handleSave}>
                    <Iconmoon icon="edit" size={14} color="#ffffff" />
                    Save
                  </Button>,
                ]
              : [
                  <Button
                    key="5"
                    className="themeBtn"
                    onClick={handleEdit}
                    disabled={!userDetails.roles.advanced_settings.edit}
                  >
                    <Iconmoon icon="edit" size={14} color="#ffffff" />
                    Edit
                  </Button>,
                ]
          }
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Units of Length</h2>
                    <p>
                      The selected units and conversion will be used as unit of
                      length
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row
                    className="centerAlign"
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    <Col span={12}>
                      <div
                        className="boxFieldTitle"
                        style={{ paddingRight: "10px" }}
                      >
                        <label>Units of Length</label>
                        <p>
                         The selected unit will be used to record length inputs
                        </p>
                        <p>
                          <Button
                            className="textTypeBtn textBtnIcon"
                            style={{ marginLeft: "0" }}
                            onClick={onClickLengthDrawer}
                          >
                            Manage Unit Conversion
                          </Button>
                          {/* <a
                            style={{
                              color: "#EA655B",
                              fontWeight: "bold",
                              lineHeight: "20px",
                            }}
                            onClick={onClickLengthDrawer}
                          >
                            Manage Unit Conversion
                          </a> */}
                        </p>
                      </div>
                    </Col>
                    {action == "edit" && (
                      <Col span={12}>
                        <div className="boxFormType">
                          <PaperMachineQualitySelect>
                            <MultiSelectCard>
                              <Multiselect
                                className="multiQuality"
                                options={lengthData}
                                style={multiselectStyle}
                                showArrow
                                selectedValues={selectedLengthUnit}
                                displayValue="label"
                                showCheckbox={true}
                                groupBy="groupBy"
                                onSelect={onChangeLengthUnitSelect}
                                onRemove={onChangeLengthUnitSelect}
                                hideSelectedList
                                keepSearchTerm
                              />
                            </MultiSelectCard>
                          </PaperMachineQualitySelect>
                        </div>
                      </Col>
                    )}
                    {!selectedLengthUnit.length ? (
                      <Col span={12}>
                        <PaperMachineGradeSelect>
                          <div className="mainMachineGrade">
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              This field is required
                            </span>
                          </div>
                        </PaperMachineGradeSelect>
                      </Col>
                    ) : (
                      <Col span={12}>
                        <PaperMachineGradeSelect>
                          <div className="mainMachineGrade">
                            {selectedLengthUnit &&
                              selectedLengthUnit.map((item, index) => {
                                return (
                                  index <= 10 && (
                                    <span
                                      className={"MachineGradeSelect-active"}
                                    >
                                      {item.label}

                                      {action == "edit" && (
                                        <Button
                                          className="textTypeBtn textBtnIcon paperButtonBg"
                                          onClick={() => {
                                            removeLength(item);
                                          }}
                                          disabled={action == "view"}
                                        >
                                          <Iconmoon
                                            icon="wrong"
                                            size={14}
                                            color="#EA655B"
                                          />
                                        </Button>
                                      )}
                                    </span>
                                  )
                                );
                              })}
                          </div>
                          {selectedLengthUnit &&
                            selectedLengthUnit.length > 10 &&
                            selectedLengthUnit.map((item, index) => {
                              let tooltipData = "";
                              for (
                                let index = 10;
                                index < selectedLengthUnit.length;
                                index++
                              ) {
                                const data = selectedLengthUnit[index];
                                tooltipData = tooltipData + data.label + ", ";
                              }
                              tooltipData = tooltipData.substring(
                                0,
                                tooltipData.length - 1
                              );

                              return (
                                index == 11 && (
                                  <Tooltip title={tooltipData}>
                                    {" "}
                                    <span
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      & {selectedLengthUnit.length - 10} More
                                    </span>
                                  </Tooltip>
                                )
                              );
                            })}
                        </PaperMachineGradeSelect>
                      </Col>
                    )}
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div
                        className="boxFieldTitle"
                        style={{ paddingRight: "10px" }}
                      >
                        <label>Default unit of Length</label>
                        <p>
                         The selected unit will be used as default unit to save length data in reports
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="default_length_unit"
                          rules={[
                            {
                              required: true,
                              message: "This is a required field",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            disabled={action === "view"}
                            showSearch
                          >
                            {selectedLengthUnit.map((unit) => (
                              <Option key={unit.value}>{unit.label}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Units of Weight</h2>
                    <p>
                      The selected units and conversion will be used as units of
                      weight
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row
                    className="centerAlign"
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    <Col span={12}>
                      <div
                        className="boxFieldTitle"
                        style={{ paddingRight: "10px" }}
                      >
                        <label>Units of Weight</label>
                        <p>
                          The selected units will be used to record weight inputs
                        </p>
                        <p>
                        <Button
                            className="textTypeBtn textBtnIcon"
                            style={{ marginLeft: "0" }}
                            onClick={onClickWeightDrawer}
                          >
                            Manage Unit Conversion
                          </Button>
                          {/* <a
                            style={{
                              color: "#EA655B",
                              fontWeight: "bold",
                              lineHeight: "20px",
                            }}
                            onClick={onClickWeightDrawer}
                          >
                            {" "}
                            Manage Unit Conversion
                          </a> */}
                        </p>
                      </div>
                    </Col>
                    {action == "edit" && (
                      <Col span={12}>
                        <div className="boxFormType">
                          <PaperMachineQualitySelect>
                            <MultiSelectCard>
                              <Multiselect
                                className="multiQuality"
                                options={weightData}
                                style={multiselectStyle}
                                showArrow={true}
                                selectedValues={selectedWeightUnit}
                                displayValue="label"
                                showCheckbox={true}
                                groupBy="groupBy"
                                onSelect={onChangeWeightUnitSelect}
                                onRemove={onChangeWeightUnitSelect}
                                hideSelectedList
                                keepSearchTerm
                              />
                            </MultiSelectCard>
                          </PaperMachineQualitySelect>
                        </div>
                      </Col>
                    )}
                    {!selectedWeightUnit.length ? (
                      <Col span={12}>
                        <PaperMachineGradeSelect>
                          <div className="mainMachineGrade">
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              This field is required
                            </span>
                          </div>
                        </PaperMachineGradeSelect>
                      </Col>
                    ) : (
                      <Col span={12}>
                        <PaperMachineGradeSelect>
                          <div className="mainMachineGrade">
                            {selectedWeightUnit &&
                              selectedWeightUnit.map((item, index) => {
                                return (
                                  index <= 10 && (
                                    <span
                                      className={"MachineGradeSelect-active"}
                                    >
                                      {item.label}

                                      {action == "edit" && (
                                        <Button
                                          disabled={action == "view"}
                                          className="textTypeBtn textBtnIcon paperButtonBg"
                                          onClick={() => {
                                            removeWeight(item);
                                          }}
                                        >
                                          <Iconmoon
                                            icon="wrong"
                                            size={14}
                                            color="#EA655B"
                                          />
                                        </Button>
                                      )}
                                    </span>
                                  )
                                );
                              })}
                          </div>
                          {selectedWeightUnit &&
                            selectedWeightUnit.length > 10 &&
                            selectedWeightUnit.map((item, index) => {
                              let tooltipData = "";
                              for (
                                let index = 10;
                                index < selectedWeightUnit.length;
                                index++
                              ) {
                                const data = selectedWeightUnit[index];
                                tooltipData = tooltipData + data.label + ", ";
                              }
                              tooltipData = tooltipData.substring(
                                0,
                                tooltipData.length - 1
                              );

                              return (
                                index == 11 && (
                                  <Tooltip title={tooltipData}>
                                    {" "}
                                    <span
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      & {selectedWeightUnit.length - 10} More
                                    </span>
                                  </Tooltip>
                                )
                              );
                            })}
                        </PaperMachineGradeSelect>
                      </Col>
                    )}
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div
                        className="boxFieldTitle"
                        style={{ paddingRight: "10px" }}
                      >
                        <label>Default unit of Weight</label>
                        <p>
                          The selected unit will be used as default unit to save weight data in reports
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="default_weight_unit"
                          rules={[
                            {
                              required: true,
                              message: "This is a required field",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            disabled={action === "view"}
                            showSearch
                            filterOption={(input, option) =>
                              option?.children
                                ?.toString()
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            {selectedWeightUnit.map((unit) => (
                              <Option key={unit.value}>{unit.label}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Units of Currency</h2>
                    <p>
                      The selected units and conversion will be used as units of
                      currency
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row
                    className="centerAlign"
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    <Col span={12}>
                      <div
                        className="boxFieldTitle"
                        style={{ paddingRight: "10px" }}
                      >
                        <label>Units of Currency</label>
                        <p>
                          The selected currencies will be used to save price inputs in reports
                        </p>
                        <p>
                        <Button
                            className="textTypeBtn textBtnIcon"
                            style={{ marginLeft: "0" }}
                            onClick={onClickCurrencyDrawer}
                          >
                            Manage Exchange Rate
                          </Button>
                          {/* <a
                            style={{
                              color: "#EA655B",
                              fontWeight: "bold",
                              lineHeight: "20px",
                            }}
                            onClick={onClickCurrencyDrawer}
                          >
                            {" "}
                            Manage Exchange Rate
                          </a> */}
                        </p>
                      </div>
                    </Col>
                    {action == "edit" && (
                      <Col span={12}>
                        <div className="boxFormType">
                          <PaperMachineQualitySelect>
                            <MultiSelectCard>
                              <Multiselect
                                className="multiQuality"
                                options={currency_List}
                                style={multiselectStyle}
                                showArrow={true}
                                selectedValues={selectedCurrencyUnit}
                                displayValue={"displayName"}
                                showCheckbox={true}
                                onSelect={onChangeCurrencyUnitSelect}
                                onRemove={onChangeCurrencyUnitSelect}
                                hideSelectedList
                                keepSearchTerm
                              />
                            </MultiSelectCard>
                          </PaperMachineQualitySelect>
                        </div>
                      </Col>
                    )}
                    {!selectedCurrencyUnit.length ? (
                      <Col span={12}>
                        <PaperMachineGradeSelect>
                          <div className="mainMachineGrade">
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              This field is required
                            </span>
                          </div>
                        </PaperMachineGradeSelect>
                      </Col>
                    ) : (
                      <Col span={12}>
                        <PaperMachineGradeSelect>
                          <div className="mainMachineGrade">
                            {selectedCurrencyUnit &&
                              selectedCurrencyUnit.map((item, index) => {
                                return (
                                  index <= 10 && (
                                    <span
                                      className={"MachineGradeSelect-active"}
                                    >
                                      {item.displayName}

                                      {action == "edit" && (
                                        <Button
                                          disabled={action == "view"}
                                          className="textTypeBtn textBtnIcon paperButtonBg"
                                          onClick={() => {
                                            removeCurrency(item);
                                          }}
                                        >
                                          <Iconmoon
                                            icon="wrong"
                                            size={14}
                                            color="#EA655B"
                                          />
                                        </Button>
                                      )}
                                    </span>
                                  )
                                );
                              })}
                          </div>
                          {selectedCurrencyUnit &&
                            selectedCurrencyUnit.length > 10 &&
                            selectedCurrencyUnit.map((item, index) => {
                              let tooltipData = "";
                              for (
                                let index = 10;
                                index < selectedCurrencyUnit.length;
                                index++
                              ) {
                                const data = selectedCurrencyUnit[index];
                                tooltipData =
                                  tooltipData + data.displayName + ", ";
                              }
                              tooltipData = tooltipData.substring(
                                0,
                                tooltipData.length - 1
                              );

                              return (
                                index == 11 && (
                                  <Tooltip title={tooltipData}>
                                    {" "}
                                    <span
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      & {selectedCurrencyUnit.length - 10} More
                                    </span>
                                  </Tooltip>
                                )
                              );
                            })}
                        </PaperMachineGradeSelect>
                      </Col>
                    )}
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div
                        className="boxFieldTitle"
                        style={{ paddingRight: "10px" }}
                      >
                        <label>Default unit of Currency</label>
                        <p>
                          The selected unit will be used as default currency
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="default_currency_unit"
                          rules={[
                            {
                              required: true,
                              message: "This is a required field",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            disabled={action === "view"}
                            showSearch
                          >
                            {selectedCurrencyUnit.map((unit) => (
                              <Option key={unit.code}>
                                {unit.displayName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>

      <ConfirmationModal
        visible={visible}
        icon={warning}
        cancelAction={modalCancel}
        confirmAction={modalConfirm}
      >
        <span>Are you sure?</span>
        <p>
          You have pending changes on this page, are you sure you want to leave?
        </p>
      </ConfirmationModal>
      {editToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setEditToaster}
          color={`green toaster`}
          icon={alertGreen}
          msg={"Measurement settings are successfully saved"}
        />
      )}
      {lengthDrawerVisible && (
        <LengthConversionUnitDrawer
          visible={lengthDrawerVisible}
          default={lengthUnitDefault}
          defaultDisplayName={lengthUnit[lengthUnitDefault].displayName}
          selectedUnit={lengthUnitData}
          type="length"
          onClose={onCloseLengthDrawer}
        ></LengthConversionUnitDrawer>
      )}
      {weightDrawerVisible && (
        <LengthConversionUnitDrawer
          visible={weightDrawerVisible}
          default={weightUnitDefault}
          defaultDisplayName={weightUnit[weightUnitDefault].displayName}
          selectedUnit={weightUnitData}
          type="weight"
          onClose={onCloseWeightDrawer}
        ></LengthConversionUnitDrawer>
      )}
      {exchangeRateDrawerVisible && (
        <ExchangeRateDrawer
          visible={exchangeRateDrawerVisible}
          default={form.getFieldValue("default_currency_unit")}
          selectedUnit={selectedCurrencyUnit}
          type="weight"
          onClose={onCloseCurrencyDrawer}
          onClickHistory={onClickHistoryDrawer}
        ></ExchangeRateDrawer>
      )}
      {historyDrawerVisible && (
        <HistoricalExchangeRateDrawer
          visible={historyDrawerVisible}
          default={form.getFieldValue("default_length_unit")}
          onClose={onCloseHistoryDrawer}
          onBack={onBackExchangeRate}
        ></HistoricalExchangeRateDrawer>
      )}
    </RightLayoutContainer>
  ) : null;
};

export default MeasurementSystem;
